export default "__VITE_ASSET__b63e97e0__"